import Modal from "bootstrap";
import tippy, { followCursor } from "tippy.js";
import "tippy.js/dist/tippy.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

tippy("[data-tippy-content]", {
	followCursor: true,
	plugins: [followCursor],
	maxWidth: 200,
});

document.addEventListener("DOMContentLoaded", function () {
	const links = document.querySelectorAll("[data-link]");

	links.forEach((item) => {
		const link = item.href;
		const slug = item.dataset.link;
		item.href = `${link}?p=${slug}`;
	});

	// Scroll animaciones
	const tl = gsap.timeline({ paused: true });

	gsap.set(".seccion", { opacity: 0, scale: 0.9, y: 30 });
	gsap.set(".flujo", { opacity: 0, y: -30 });
	gsap.set(".marcador", { opacity: 0, y: -30 });
	gsap.set(".tooltip-block", { opacity: 0, scale: 0 });

	tl.to(".seccion", { opacity: 1, scale: 1, y: 0, stagger: 0.1 })
		.to(".flujo", { opacity: 1, y: 0, stagger: 0.1 })
		.to(".marcador", { opacity: 1, y: 0, stagger: 0.1 })
		.to(".tooltip-block", { opacity: 1, scale: 1, stagger: 0.1 });

	ScrollTrigger.create({
		trigger: ".diagrama",
		start: "top 50%",
		end: "bottom 50%+=100px",
		// markers: true,
		onEnter: function () {
			tl.timeScale(1).play();
		},
		onLeaveBack: function () {
			tl.timeScale(2).reverse();
		},
	});
});
